import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
  label: PropTypes.string.isRequired,
  component: PropTypes.node.isRequired,
};
const defaultProps = {};

const TabItem = ({ component, label, ...rest }) => (
  <div {...rest}>{component}</div>
);

TabItem.propTypes = propTypes;
TabItem.defaultProps = defaultProps;

export default TabItem;
